import React, { useState } from 'react';

import { Check } from 'Src/feature/check/models';
import { TipSuggestion } from 'Src/feature/check/useCheck';

interface UseFlipAndTipTotalsOptions {
  payment?: Check['payments'][number];
  defaultTipSuggestion?: TipSuggestion;
}

const useFlipAndTipTotals = ({ payment, defaultTipSuggestion }: UseFlipAndTipTotalsOptions) => {
  const [selectedTipSuggestion, selectedTipSuggestionSet] = useState(defaultTipSuggestion as TipSuggestion | undefined);
  const [customTip, customTipSet] = useState(undefined as string | undefined);

  const { amountAppliedToCheck = 0 } = payment ?? {};

  let tipValue = 0;
  let finalTotal = amountAppliedToCheck;
  if (selectedTipSuggestion) {
    tipValue = selectedTipSuggestion.tip;
    finalTotal = selectedTipSuggestion.total;
  } else if (customTip) {
    tipValue = parseFloat(customTip);
    const totalFixed = (amountAppliedToCheck + tipValue).toFixed(2);
    finalTotal = parseFloat(totalFixed);
  }

  const handleCustomTipChange = (value: string | undefined) => {
    if (value) selectedTipSuggestionSet(undefined);
    customTipSet(value);
  };

  const handleTipSuggestionClick = (value: TipSuggestion | undefined) => {
    if (value) customTipSet(undefined);
    selectedTipSuggestionSet(value);
  };

  const handleNoTipClick = () => {
    selectedTipSuggestionSet(undefined);
    customTipSet(undefined);
  };

  return {
    handleTipSuggestionClick,
    handleCustomTipChange,
    handleNoTipClick,
    selectedTipSuggestion,
    customTip,
    finalTotal,
    tipValue,
    amountAppliedToCheck,
  };
};

export { useFlipAndTipTotals };
